<div class="grid">
  @if (cookieRole === 'SYSADMIN') {
    <mat-form-field
      class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
      appearance="outline">
      <mat-label>Empresa</mat-label>
      <mat-select [(ngModel)]="businessId" [(value)]="selectValueCompani">
        <mat-option [value]="-1" (click)="ObtenerEdificios(-1)">
          Generales
        </mat-option>
        @for (buss of bussines; track buss) {
          <mat-option
            [value]="buss.idBusiness"
            (click)="ObtenerEdificios(buss.idBusiness!)">
            {{ buss.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  <mat-form-field
    class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
    appearance="outline">
    <mat-label>Edificio</mat-label>
    <mat-select [(ngModel)]="buildingId">
      @for (edificio of edificios; track edificio) {
        <mat-option
          [value]="edificio.buildingid"
          (click)="chargueFloorByBuilding(edificio.buildingid)">
          {{ edificio.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
    appearance="outline">
    <mat-label>Nivel</mat-label>
    <mat-select [(ngModel)]="floorId">
      @for (floor of floors; track floor) {
        <mat-option
          [value]="floor.floorid"
          (click)="selectFloor(floor.floorid)">
          {{ floor.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
    appearance="outline">
    <mat-label>Tipo de puesto</mat-label>
    <mat-select [(ngModel)]="workPlaceId">
      @for (puesto of puestos; track puesto) {
        <mat-option
          [value]="puesto.workplacetypeid"
          (click)="selectType(puesto.workplacetypeid)">
          {{ puesto.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field
    class="col-12 sm:col-12 md:col-6 lg:col-3 xl:col-4"
    appearance="outline">
    <mat-label>Rango de fechas</mat-label>
    <mat-select [(ngModel)]="filter">
      @for (range of rangeFilter(); track range) {
        <mat-option [value]="range.value" (click)="getReservationsGraphic()">
          {{ range.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div
  class="justify-content-center ms:justify-content-center md:flex md:align-items-center md:justify-content-center lg:flex lg:align-items-center lg:justify-content-center xl:flex xl:align-items-center xl:justify-content-center lg:pt-6">
  <div class="flex align-items-center">
    <ngx-charts-heat-map
      id="reservations"
      [view]="view"
      [scheme]="colorScheme"
      [results]="multi"
      [legend]="showLegend"
      [gradient]="gradient"
      [xAxis]="showXAxis"
      [yAxis]="showYAxis"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [xAxisLabel]="xAxisLabel"
      [yAxisLabel]="yAxisLabel"
      (select)="onSelect($event)">
    </ngx-charts-heat-map>
    <div class="y-axis-label">Cantidad de Reservas</div>
  </div>
  <div
    class="flex flex-column justify-content-center pt-3 pl-8 xl:pl-4 lg:pl-4 flex-column md:flex-row gap-3 justify-content-center md:justify-content-end mb-2 ms:justify-content-center dm:flex md:gap-3 md:justify-content-end md:flex-wrap md:mb-7 lg:flex lg:gap-3 lg:justify-content-end lg:flex-wrap mb-7 xl:flex xl:gap-3 xl:justify-content-end xl:flex-wrap xl:mb-7">
    <shared-button
      [icon]="'save_alt'"
      [typeBtn]="'button'"
      (click)="downloadExcel()"
      color="accent">
      Excel
    </shared-button>
    <shared-button
      [icon]="'save_alt'"
      [typeBtn]="'button'"
      (click)="download()"
      color="accent">
      P D F
    </shared-button>
  </div>
</div>
